import React from 'react';

import { Text, TextType, TextSize, TextWeight } from '@/shared/ui';

export const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();
    return (
        <div className='flex w-[100%] justify-between items-center mt-auto px-[10%] py-[32px] bg-background-primary border-t border-border-opaque'>
            <Text
                type={TextType.Paragraph}
                size={TextSize.MD}
                fontWeight={TextWeight.Regular}
                className='text-content-secondary'
            >
                Arkis © {currentYear}. All rights reserved.
            </Text>
            <div className='flex gap-[1.5rem]'>
                <Text
                    type={TextType.Link}
                    size={TextSize.MD}
                    fontWeight={TextWeight.SemiBold}
                    className='text-content-secondary hover:underline'
                >
                    <a href='/terms-and-conditions'>Terms of Use</a>
                </Text>
                {/*<Text*/}
                {/*    type={TextType.Link}*/}
                {/*    size={TextSize.MD}*/}
                {/*    fontWeight={TextWeight.Regular}*/}
                {/*    className='text-content-secondary hover:underline'*/}
                {/*>*/}
                {/*    <a href='/privacy-policy'>Privacy Policy</a>*/}
                {/*</Text>*/}
            </div>
        </div>
    );
};
